import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import './App.css';
import './style.css';
import Login from './screens/Auth/Login';
import Dashboard from './screens/Dashboard/dashboard';
import { Provider, useDispatch } from 'react-redux'
import configureStore from '../src/store/store'
import TypeOfCustomer from "./screens/Master/TypeOfCustomer/indexType";
import AddTypeOfCustomer from "./screens/Master/TypeOfCustomer/addType";
import InsuranceCompanies from "./screens/Master/InsuranceCompanies/indexInsurance";
import AddInsuranceCompanies from "./screens/Master/InsuranceCompanies/addInsurance";
import States from "./screens/Master/State";
import VehicleType from "./screens/Master/VehicleType";
import AddVehicleType from "./screens/Master/VehicleType/add";
import Vendor from "./screens/Master/Vendors";
import AddVendors from "./screens/Master/Vendors/add";
import AddTypeOfInsurance from "./screens/Master/TypeOfInsurance/add";
import TypeOfInsurance from "./screens/Master/TypeOfInsurance";
import AddCoverage from "./screens/Master/Coverage/add";
import Coverage from "./screens/Master/Coverage";
import AddPayment from "./screens/Master/PaymentType/add";
import Payment from "./screens/Master/PaymentType";
import Estimate from "./screens/Estimate";
import AddEstimate from "./screens/Estimate/add";
import JobCard from "./screens/JobCard";
import AddJobCard from "./screens/JobCard/add";
import BulkEntries from "./screens/BulkExpense";
import AddBulkEntries from "./screens/BulkExpense/add";
import Suppliers from "./screens/Suppliers";
import EditCustomerType from "./screens/Master/TypeOfCustomer/editType";
import EditInsuranceCompany from "./screens/Master/InsuranceCompanies/edit";
import EditInsuranceType from "./screens/Master/TypeOfInsurance/edit";
import Client from "./screens/Master/CorporateClients";
import AddClient from "./screens/Master/CorporateClients/add";
import EditClient from "./screens/Master/CorporateClients/edit";
import AddState from "./screens/Master/State/add";
import EditState from "./screens/Master/State/edit";
import Color from "./screens/Master/VehicleColour";
import AddColor from "./screens/Master/VehicleColour/add";
import EditColor from "./screens/Master/VehicleColour/edit";
import EditVehicleType from "./screens/Master/VehicleType/edit";
import VehicleMake from "./screens/Master/VehicleMake";
import AddVehicleMake from "./screens/Master/VehicleMake/add";
import EditVehicleMake from "./screens/Master/VehicleMake/edit";
import EditVendors from "./screens/Master/Vendors/edit";
import EditCoverage from "./screens/Master/Coverage/edit";
import EditPaymentType from "./screens/Master/PaymentType/edit";
import AddSupplier from "./screens/Suppliers/add";
import AddInvestigation from "./screens/Investigation/investigation";
import Investigation from "./screens/Investigation";
import Customers from "./screens/Customers";
import AddCustomer from "./screens/Customers/add";
import AddPoliceStation from "./screens/Master/Police/add";
import PoliceStation from "./screens/Master/Police";
import EditPoliceStation from "./screens/Master/Police/edit";
import Vehicle from "./screens/Master/Vehicle";
import AddVehicle from "./screens/Master/Vehicle/add";
import EditVehicle from "./screens/Master/Vehicle/edit";
import VehicleCode from "./screens/Master/VehicleCode";
import AddVehicleCode from "./screens/Master/VehicleCode/add";
import EditVehicleCode from "./screens/Master/VehicleCode/edit";
import VehicleModel from "./screens/Master/VehicleModel";
import AddVehicleModel from "./screens/Master/VehicleModel/add";
import EditVehicleModel from "./screens/Master/VehicleModel/edit";
import EditCustomer from "./screens/Customers/edit";
import EditSupplier from "./screens/Suppliers/edit";
import Product from "./screens/Products";
import AddProduct from "./screens/Products/add";
import EditProduct from "./screens/Products/edit";
import ProductCategory from "./screens/ProductCategories";
import AddProductCategory from "./screens/ProductCategories/add";
import EditProductCategory from "./screens/ProductCategories/edit";
import PerformaInvoices from "./screens/PerformaInvoices";
import PerformaInvoiceDetail from "./screens/PerformaInvoices/PerformaInvoiceDetail";
import EditInvestigation from "./screens/Investigation/edit/investigation";
import EditEstimate from "./screens/Estimate/edit";
import EditJobCard from "./screens/JobCard/edit";
import { useEffect } from "react";
import ProtectedRoute from "./components/ProtectedRoute";
import { logoutIndex } from "./actions/AuthActions";
import Drivers from "./screens/Drivers";
import AddDriver from "./screens/Drivers/add";
import ReplacementOfVehicle from "./screens/ReplacementOfVehicles";
import AddReplacementOfVehicle from "./screens/ReplacementOfVehicles/add";
import ReplacementVehicle from "./screens/ReplacementVehicles";
import AddReplacementVehicle from "./screens/ReplacementVehicles/add";
import Batch from "./screens/Batch";
import Invoice from "./screens/Batch/invoice";
import ParallelJobs from "./screens/Batch/parallelJob";
import AddBatch from "./screens/Batch/add";
import EditDriver from "./screens/Drivers/edit";
import EditReplacementVehicle from "./screens/ReplacementVehicles/edit";
import EditReplacementOfVehicle from "./screens/ReplacementOfVehicles/edit";
import DriverVehicles from "./screens/DriverPortal";
import ReplacementForm from "./screens/DriverPortal/replacementForm";
import EditBatch from "./screens/Batch/edit";
import TechnicalReport from "./screens/ReplacementOfVehicles/technicalReport";
import Tracking from "./screens/ReplacementOfVehicles/driverTracking";
import DriverTracking from "./screens/ReplacementOfVehicles/driverTracking";
import LeaseBatch from "./screens/LeaseBatch";
import AddLeaseBatch from "./screens/LeaseBatch/add";
import EditLeaseBatch from "./screens/LeaseBatch/edit";
import axios from 'axios';
import Toast from "./components/Toast";
import Users from "./screens/Users";
import Permissions from "./screens/Users/Permissions";
import Unauthorized from "./screens/unauthorized";
import InvoiceJobCard from "./screens/JobCard/invoice";
import InvoiceEstimate from "./screens/Estimate/invoice";
import TaxInvoice from "./screens/JobCard/taxInvoice";
import ExcessTaxInvoice from "./screens/JobCard/excessTaxInvoice";
import AddUser from "./screens/Users/add";
import EditUser from "./screens/Users/edit";
import InsuranceReport from "./screens/Reports";
import InsuranceStatementPrint from "./screens/Reports/invoice";
import InvestigationScheduleReport from "./screens/Reports/investigationSchedule";
import EstimateScheduleReport from "./screens/Reports/estimateSchedule";
import PriceStatementReport from "./screens/Reports/priceStatement";
import JobCardScheduleReport from "./screens/Reports/jobCardSchedule";
import CostStatementReport from "./screens/Reports/costStatement";
import StatementMeethaqTakafulInsuranceReport from "./screens/Reports/statementMeethaqTakafulInsurance";
import InvoiceInvestigation from "./screens/Investigation/invoice";

const store = configureStore();

function App() {

  useEffect(() => {
    window.addEventListener('storage', e => {
      // console.log(
      if (e.key === 'user' && e.oldValue && !e.newValue) {
        // console.log('logged out')
        window.location.reload();
        // store.dispatch(logoutIndex());
        // dispatch(logoutIndex());
      }
    });
  }, [])

  // Define your user_token and user values
  const userToken = localStorage.getItem('user_token');
  const user = localStorage.getItem('user');
  const user_permissions = JSON.parse(localStorage.getItem('perm'));

  // Define the API endpoint
  const apiUrl = 'https://garage-manager.clouxiplexi.com/api/verifyApiToken';
  useEffect(() => {
    axios.get(apiUrl, {
      params: {
        user_token: userToken,
        user: user
      }
    })
      .then(response => {
        // Handle the successful response
        console.log(response);
      })
      .catch(error => {
        // Handle the error
        if (error.response && error.response.status === 401) {
          // Token has expired, clear localStorage
          clearLocalStorage();
          window.location.href = '/';
          Toast.fire({
            icon: 'error',
            title: 'Session Expired! Please Login.'
          })
        }
        console.error('Error making API call:', error);
      });
  }, [])

  function clearLocalStorage() {
    localStorage.removeItem('user_token');
    localStorage.removeItem('user');
    localStorage.removeItem('perm');
  }

  return (
    <div className="App">
      <Provider store={store}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/dashboard" element={<ProtectedRoute ><Dashboard requiredPermissionId="1" /></ProtectedRoute>} />

            <Route path="/unauthorized" element={<ProtectedRoute><Unauthorized /></ProtectedRoute>} />

            <Route path="/typeOfCustomer" element={<ProtectedRoute><TypeOfCustomer requiredPermissionId="35" /></ProtectedRoute>} />
            <Route path="/typeOfCustomer/add" element={<ProtectedRoute><AddTypeOfCustomer requiredPermissionId="35" /></ProtectedRoute>} />
            <Route path="/typeOfCustomer/:id" element={<ProtectedRoute><EditCustomerType requiredPermissionId="35" /></ProtectedRoute>} />

            <Route path="/insuranceCompany" element={<ProtectedRoute><InsuranceCompanies requiredPermissionId="35" /></ProtectedRoute>} />
            <Route path="/insuranceCompany/add" element={<ProtectedRoute><AddInsuranceCompanies requiredPermissionId="35" /></ProtectedRoute>} />
            <Route path="/insuranceCompany/:id" element={<ProtectedRoute><EditInsuranceCompany requiredPermissionId="35" /></ProtectedRoute>} />

            <Route path="/typeOfInsurance" element={<ProtectedRoute><TypeOfInsurance requiredPermissionId="35" /></ProtectedRoute>} />
            <Route path="/typeOfInsurance/add" element={<ProtectedRoute><AddTypeOfInsurance requiredPermissionId="35" /></ProtectedRoute>} />
            <Route path="/typeOfInsurance/:id" element={<ProtectedRoute><EditInsuranceType requiredPermissionId="35" /></ProtectedRoute>} />

            <Route path="/client" element={<ProtectedRoute><Client requiredPermissionId="35" /></ProtectedRoute>} />
            <Route path="/client/add" element={<ProtectedRoute><AddClient requiredPermissionId="35" /></ProtectedRoute>} />
            <Route path="/client/:id" element={<ProtectedRoute><EditClient requiredPermissionId="35" /></ProtectedRoute>} />

            <Route path="/state" element={<ProtectedRoute><States requiredPermissionId="35" /></ProtectedRoute>} />
            <Route path="/state/add" element={<ProtectedRoute><AddState requiredPermissionId="35" /></ProtectedRoute>} />
            <Route path="/state/:id" element={<ProtectedRoute><EditState requiredPermissionId="35" /></ProtectedRoute>} />

            <Route path="/vendor" element={<ProtectedRoute><Vendor requiredPermissionId="35" /></ProtectedRoute>} />
            <Route path="/vendor/add" element={<ProtectedRoute><AddVendors requiredPermissionId="35" /></ProtectedRoute>} />
            <Route path="/vendor/:id" element={<ProtectedRoute><EditVendors requiredPermissionId="35" /></ProtectedRoute>} />

            <Route path="/policeStation" element={<ProtectedRoute><PoliceStation requiredPermissionId="35" /></ProtectedRoute>} />
            <Route path="/policeStation/add" element={<ProtectedRoute><AddPoliceStation requiredPermissionId="35" /></ProtectedRoute>} />
            <Route path="/policeStation/:id" element={<ProtectedRoute><EditPoliceStation requiredPermissionId="35" /></ProtectedRoute>} />

            <Route path="/coverage" element={<ProtectedRoute><Coverage requiredPermissionId="35" /></ProtectedRoute>} />
            <Route path="/coverage/add" element={<ProtectedRoute><AddCoverage requiredPermissionId="35" /></ProtectedRoute>} />
            <Route path="/coverage/:id" element={<ProtectedRoute><EditCoverage requiredPermissionId="35" /></ProtectedRoute>} />

            <Route path="/paymentType" element={<ProtectedRoute><Payment requiredPermissionId="35" /></ProtectedRoute>} />
            <Route path="/paymentType/add" element={<ProtectedRoute><AddPayment requiredPermissionId="35" /></ProtectedRoute>} />
            <Route path="/paymentType/:id" element={<ProtectedRoute><EditPaymentType requiredPermissionId="35" /></ProtectedRoute>} />

            <Route path="/vehicle" element={<ProtectedRoute><Vehicle requiredPermissionId="36" /></ProtectedRoute>} />
            <Route path="/vehicle/add" element={<ProtectedRoute><AddVehicle requiredPermissionId="36" /></ProtectedRoute>} />
            <Route path="/vehicle/:id" element={<ProtectedRoute><EditVehicle requiredPermissionId="36" /></ProtectedRoute>} />

            <Route path="/replacementVehicle" element={<ProtectedRoute><ReplacementVehicle requiredPermissionId="36" /></ProtectedRoute>} />
            <Route path="/replacementVehicle/add" element={<ProtectedRoute><AddReplacementVehicle requiredPermissionId="36" /></ProtectedRoute>} />
            <Route path="/replacementVehicle/:id" element={<ProtectedRoute><EditReplacementVehicle requiredPermissionId="36" /></ProtectedRoute>} />

            <Route path="/vehicleType" element={<ProtectedRoute><VehicleType requiredPermissionId="36" /></ProtectedRoute>} />
            <Route path="/vehicleType/add" element={<ProtectedRoute><AddVehicleType requiredPermissionId="36" /></ProtectedRoute>} />
            <Route path="/vehicleType/:id" element={<ProtectedRoute><EditVehicleType requiredPermissionId="36" /></ProtectedRoute>} />

            <Route path="/color" element={<ProtectedRoute><Color requiredPermissionId="36" /></ProtectedRoute>} />
            <Route path="/color/add" element={<ProtectedRoute><AddColor requiredPermissionId="36" /></ProtectedRoute>} />
            <Route path="/color/:id" element={<ProtectedRoute><EditColor requiredPermissionId="36" /></ProtectedRoute>} />

            <Route path="/vehicleMake" element={<ProtectedRoute><VehicleMake requiredPermissionId="36" /></ProtectedRoute>} />
            <Route path="/vehicleMake/add" element={<ProtectedRoute><AddVehicleMake requiredPermissionId="36" /></ProtectedRoute>} />
            <Route path="/vehicleMake/:id" element={<ProtectedRoute><EditVehicleMake requiredPermissionId="36" /></ProtectedRoute>} />

            <Route path="/vehicleCode" element={<ProtectedRoute><VehicleCode requiredPermissionId="36" /></ProtectedRoute>} />
            <Route path="/vehicleCode/add" element={<ProtectedRoute><AddVehicleCode requiredPermissionId="36" /></ProtectedRoute>} />
            <Route path="/vehicleCode/:id" element={<ProtectedRoute><EditVehicleCode requiredPermissionId="36" /></ProtectedRoute>} />

            <Route path="/vehicleModel" element={<ProtectedRoute><VehicleModel requiredPermissionId="36" /></ProtectedRoute>} />
            <Route path="/vehicleModel/add" element={<ProtectedRoute><AddVehicleModel requiredPermissionId="36" /></ProtectedRoute>} />
            <Route path="/vehicleModel/:id" element={<ProtectedRoute><EditVehicleModel requiredPermissionId="36" /></ProtectedRoute>} />

            <Route path="/investigation" element={<ProtectedRoute><Investigation requiredPermissionId="2" /></ProtectedRoute>} />
            <Route path="/investigation/add" element={<ProtectedRoute><AddInvestigation requiredPermissionId="3" /></ProtectedRoute>} />
            <Route path="/investigation/add/:id" element={<ProtectedRoute><AddInvestigation requiredPermissionId="4" /></ProtectedRoute>} />
            <Route path="/investigation/edit/:id" element={<ProtectedRoute><EditInvestigation requiredPermissionId="4" /></ProtectedRoute>} />
            {/* <Route path="/investigation/invoice/:id" element={<ProtectedRoute><InvoiceInvestigation requiredPermissionId="2" /></ProtectedRoute>} /> */}

            <Route path="/estimates" element={<ProtectedRoute><Estimate requiredPermissionId="5" /></ProtectedRoute>} />
            <Route path="/estimate/add" element={<ProtectedRoute><AddEstimate requiredPermissionId="6" /></ProtectedRoute>} />
            <Route path="/estimate/add/:investigation_id" element={<ProtectedRoute><AddEstimate requiredPermissionId="7" /></ProtectedRoute>} />
            <Route path="/estimate/edit/:estimate_id" element={<ProtectedRoute><EditEstimate requiredPermissionId="7" /></ProtectedRoute>} />
            <Route path="/estimate/invoice/:estimate_id" element={<ProtectedRoute><InvoiceEstimate requiredPermissionId="5" /></ProtectedRoute>} />


            <Route path="/jobCard" element={<ProtectedRoute><JobCard requiredPermissionId="8" /></ProtectedRoute>} />
            <Route path="/jobCard/add" element={<ProtectedRoute><AddJobCard requiredPermissionId="9" /></ProtectedRoute>} />
            <Route path="/jobCard/add/:estimate_id" element={<ProtectedRoute><AddJobCard requiredPermissionId="10" /></ProtectedRoute>} />
            <Route path="/jobCard/edit/:job_card_id" element={<ProtectedRoute><EditJobCard requiredPermissionId="10" /></ProtectedRoute>} />
            <Route path="/jobCard/invoice/:job_card_id" element={<ProtectedRoute><InvoiceJobCard requiredPermissionId="8" /></ProtectedRoute>} />
            <Route path="/jobCard/taxInvoice/:job_card_id" element={<ProtectedRoute><TaxInvoice requiredPermissionId="8" /></ProtectedRoute>} />
            <Route path="/jobCard/excessTaxInvoice/:job_card_id" element={<ProtectedRoute><ExcessTaxInvoice requiredPermissionId="8" /></ProtectedRoute>} />

            {/* <Route path="/bulkEntries" element={<ProtectedRoute><BulkEntries /></ProtectedRoute>} />
            <Route path="/bulkEntries/add" element={<ProtectedRoute><AddBulkEntries /></ProtectedRoute>} /> */}

            <Route path="/suppliers" element={<ProtectedRoute><Suppliers requiredPermissionId="26" /></ProtectedRoute>} />
            <Route path="/supplier/add" element={<ProtectedRoute><AddSupplier requiredPermissionId="27" /></ProtectedRoute>} />
            <Route path="/supplier/:id" element={<ProtectedRoute><EditSupplier requiredPermissionId="28" /></ProtectedRoute>} />

            <Route path="/customers" element={<ProtectedRoute><Customers requiredPermissionId="23" /></ProtectedRoute>} />
            <Route path="/customer/add" element={<ProtectedRoute><AddCustomer requiredPermissionId="24" /></ProtectedRoute>} />
            <Route path="/customer/:id" element={<ProtectedRoute><EditCustomer requiredPermissionId="25" /></ProtectedRoute>} />

            <Route path="/products" element={<ProtectedRoute><Product requiredPermissionId="17" /></ProtectedRoute>} />
            <Route path="/product/add" element={<ProtectedRoute><AddProduct requiredPermissionId="18" /></ProtectedRoute>} />
            <Route path="/product/:id" element={<ProtectedRoute><EditProduct requiredPermissionId="19" /></ProtectedRoute>} />

            <Route path="/productCategories" element={<ProtectedRoute><ProductCategory requiredPermissionId="14" /></ProtectedRoute>} />
            <Route path="/productCategory/add" element={<ProtectedRoute><AddProductCategory requiredPermissionId="15" /></ProtectedRoute>} />
            <Route path="/productCategory/:id" element={<ProtectedRoute><EditProductCategory requiredPermissionId="16" /></ProtectedRoute>} />

            <Route path="/performaInvoices" element={<ProtectedRoute><PerformaInvoices /></ProtectedRoute>} />
            <Route path="/performaInvoice/:id" element={<ProtectedRoute><PerformaInvoiceDetail /></ProtectedRoute>} />

            <Route path="/drivers" element={<ProtectedRoute><Drivers requiredPermissionId="32" /></ProtectedRoute>} />
            <Route path="/driver/add" element={<ProtectedRoute><AddDriver requiredPermissionId="33" /></ProtectedRoute>} />
            <Route path="/driver/:id" element={<ProtectedRoute><EditDriver requiredPermissionId="34" /></ProtectedRoute>} />
            <Route path="/driver/vehicles" element={<ProtectedRoute><DriverVehicles requiredPermissionId="37" /></ProtectedRoute>} />
            <Route path="/driver/replacementForm/:id" element={<ProtectedRoute><ReplacementForm requiredPermissionId="38" /></ProtectedRoute>} />

            <Route path="/users" element={<ProtectedRoute><Users requiredPermissionId="29" /></ProtectedRoute>} />
            <Route path="/user/add" element={<ProtectedRoute><AddUser requiredPermissionId="30" /></ProtectedRoute>} />
            <Route path="/user/permissions/:user_id" element={<ProtectedRoute><Permissions requiredPermissionId="30" /></ProtectedRoute>} />
            <Route path="/user/edit/:user_id" element={<ProtectedRoute><EditUser requiredPermissionId="30" /></ProtectedRoute>} />

            <Route path="/insurance-report" element={<InsuranceReport />} />
            <Route path="/insurance-report-print" element={<InsuranceStatementPrint />} />

            <Route path="/investigation-schedule-report" element={<InvestigationScheduleReport />} />
            <Route path="/estimate-schedule-report" element={<EstimateScheduleReport />} />
            <Route path="/price-statement-report" element={<PriceStatementReport />} />
            <Route path="/job-card-schedule-report" element={<JobCardScheduleReport />} />
            <Route path="/cost-statement-report" element={<CostStatementReport />} />
            <Route path="/statement-insurance-report" element={<StatementMeethaqTakafulInsuranceReport />} />

            <Route path="/replacementOfVehicle" element={<ProtectedRoute><ReplacementOfVehicle requiredPermissionId="20" /></ProtectedRoute>} />
            <Route path="/replacementOfVehicle/add" element={<ProtectedRoute><AddReplacementOfVehicle requiredPermissionId="21" /></ProtectedRoute>} />
            <Route path="/replacementOfVehicle/:id" element={<ProtectedRoute><EditReplacementOfVehicle requiredPermissionId="22" /></ProtectedRoute>} />
            <Route path="/technicalReport/:id" element={<ProtectedRoute><TechnicalReport requiredPermissionId="21" /></ProtectedRoute>} />
            <Route path="/tracking/:id" element={<ProtectedRoute><DriverTracking requiredPermissionId="22" /></ProtectedRoute>} />

            <Route path="/batch" element={<ProtectedRoute><Batch requiredPermissionId="11" /></ProtectedRoute>} />
            <Route path="/batch/add" element={<ProtectedRoute><AddBatch requiredPermissionId="12" /></ProtectedRoute>} />
            <Route path="/batch/edit/:id" element={<ProtectedRoute><EditBatch requiredPermissionId="13" /></ProtectedRoute>} />
            <Route path="/invoice/:id" element={<ProtectedRoute><Invoice requiredPermissionId="12" /></ProtectedRoute>} />
            <Route path="/parallelJobs/:id" element={<ProtectedRoute><ParallelJobs requiredPermissionId="12" /></ProtectedRoute>} />
            {/* <Route path="/customer/:id" element={<ProtectedRoute><EditCustomer /></ProtectedRoute>} /> */}

            <Route path="/leaseBatch" element={<ProtectedRoute><LeaseBatch requiredPermissionId="39" /></ProtectedRoute>} />
            <Route path="/leaseBatch/add" element={<ProtectedRoute><AddLeaseBatch requiredPermissionId="40" /></ProtectedRoute>} />
            <Route path="/leaseBatch/edit/:id" element={<ProtectedRoute><EditLeaseBatch requiredPermissionId="40" /></ProtectedRoute>} />
            <Route path="/leaseBatch/invoice/:id" element={<ProtectedRoute><Invoice requiredPermissionId="40" /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </Provider>
    </div >
  );
}

export default App;
